import script from "./RightsideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightsideBar.vue?vue&type=script&setup=true&lang=js"

import "./RightsideBar.vue?vue&type=style&index=0&id=10054a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10054a6a"]])

export default __exports__